<template>
  <Header :curScreen="curScreen" />
  
  <StartScreen v-if="curScreen === 'StartScreenId'" @go-to-event="goToScreen"  />
  <SelectionScreen v-if="curScreen === 'SelectionScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" />
  <VideoScreen v-if="curScreen === 'VideoScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" />
  <InfoScreen v-if="curScreen === 'InfoScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" />
  <PathSelectionScreen v-if="curScreen === 'PathSelectionScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" @clear-event-types="clearEventTypes"/>
  <ToWhomScreen v-if="curScreen === 'ToWhomScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <ToWhomSelfScreen v-if="curScreen === 'ToWhomSelfScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <RealizeScreen v-if="curScreen === 'RealizeScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <RealizeSelfScreen v-if="curScreen === 'RealizeSelfScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <ContractFiguresScreen v-if="curScreen === 'ContractFiguresScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <ContractFiguresSelfScreen v-if="curScreen === 'ContractFiguresSelfScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <HowMuchScreen v-if="curScreen === 'HowMuchScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <HowMuchSelfScreen v-if="curScreen === 'HowMuchSelfScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <CoverageScreen v-if="curScreen === 'CoverageScreenId'" @go-to-event="goToScreen" @go-back-event="goBack" :formData="formData" @save-form-data-event="saveFormData" />
  <ResultScreen v-if="curScreen === 'ResultScreenId'" @print="exportToPDF" @go-to-event="goToScreen" @go-back-event="goBack" :showLoader="showLoader" :formData="formData"  />
</template>

<script>
import Header from './components/Header.vue';
import StartScreen from './components/screen/StartScreen.vue';
import SelectionScreen from './components/screen/SelectionScreen.vue';
import VideoScreen from './components/screen/VideoScreen.vue';
import InfoScreen from './components/screen/InfoScreen.vue';
import PathSelectionScreen from './components/screen/PathSelectionScreen.vue';
import ToWhomScreen from './components/screen/ToWhomScreen.vue';
import ToWhomSelfScreen from './components/screen/ToWhomSelfScreen.vue';
import RealizeScreen from './components/screen/RealizeScreen.vue';
import RealizeSelfScreen from './components/screen/RealizeSelfScreen.vue';
import HowMuchScreen from './components/screen/HowMuchScreen.vue';
import HowMuchSelfScreen from './components/screen/HowMuchSelfScreen.vue';
import ContractFiguresScreen from './components/screen/ContractFiguresScreen.vue';
import ContractFiguresSelfScreen from './components/screen/ContractFiguresSelfScreen.vue';
import CoverageScreen from './components/screen/CoverageScreen.vue';
import ResultScreen from './components/screen/ResultScreen.vue';
import html2pdf from 'html2pdf.js'

export default {
  name: 'App',
  components: {
    Header,
    StartScreen,
    SelectionScreen,
    VideoScreen,
    InfoScreen,
    PathSelectionScreen,
    ToWhomScreen,
    ToWhomSelfScreen,
    RealizeScreen,
    RealizeSelfScreen,
    HowMuchScreen,
    HowMuchSelfScreen,
    ContractFiguresScreen,
    ContractFiguresSelfScreen,
    CoverageScreen,
    ResultScreen,
    
  },
  data() {
    return {
      curScreen: "StartScreenId",
      screenHistory: [],
      showLoader: false,
      formData: {
        contractFigure: {
            firstName: null,
            lastName: null,
            dateOfBirth: null,
            address: null,
            email: null,
            telephone: null,
        },
        insuredFigure: {
            firstName: null,
            lastName: null,
            email: null,
            telephone: null,
            dateOfBirth: null,
            address: null,
        },
        beneficiaryFigure: {
            firstName: null,
            lastName: null,
        },
        personType: null,
        firstName: null,
        dateOfBirth: null,

        eventTypes: [],

        duration: null,
        planType: null,
        amountChosen: null,
        amountAnnual: null,
        amountCalculated: null,
        installmentType: '',
        installmentAmount: null,

        deathCoverage: false,
        deathCoverageDuration: null,
        deathCoverageAmount: null,
        deathCoverageCalculated: 0,
        deathCoverageTotal: 0,
        diseaseCoverage: false,
        diseaseCoverageDuration: null,
        diseaseCoverageAmount: null,
        diseaseCoverageCalculated: 0,
        diseaseCoverageTotal: 0,
      }
    }
  },
  methods: {
    exportToPDF() {
      this.showLoader = true;
      html2pdf(document.getElementById('pdf'), {
        margin: [10, 20, 10, 20],
        filename: 'bg-insieme-report.pdf',
        image: { type: 'png', quality: 1 },
        html2canvas:  { scale: 4 }
      }).then( () => {
        // Must be arrow function, else this is out of scope
        this.showLoader = false;
      });
    },

    // Proceed forward changes screen depending on screen id.
    goToScreen(destinationId) {
      // console.log(`Switched from ${this.curScreen} to ${destinationId}`);
      // Add old screen to history before setting to new screen
      this.screenHistory.push(this.curScreen);
      this.curScreen = destinationId;
    },
    // Pop last screen from history and set it as current screen
    goBack() {
      this.curScreen = this.screenHistory.pop();
      // console.log(`Went back to ${this.curScreen}`);
    },
    // Save form data to App data
    saveFormData(formData) {
      Object.keys(formData).forEach(key => {
        this.formData[key] = formData[key];
      });
    },
    clearEventTypes() {
      this.formData.eventTypes = [];
      this.formData.firstName = null;
      this.formData.personType = null;
    }
  }
}

new bootstrap.Tooltip(document.body, {
  container: '#app',
  selector: "[data-bs-toggle='tooltip']",
  delay: {show: 150, hide: 150},
  placement: 'right',
  popperConfig: { strategy: 'absolute' },
});


</script>

<style>

</style>
